<!--
 * @Author: Gaho
 * @Date: 2024-04-16 10:41:51
 * @LastEditors: Gaho
 * @LastEditTime: 2024-06-21 13:21:44
 * @Description: 
-->
<template>
    <div class="circle-details">
        <div class="details-board" :style="{ 'border-color': resultColor }">
            <!-- 轮盘 -->
            <img src="@/assets/imgs/casino/circle/circle.svg" :style="degree" alt="">
            <!-- 下注结果 -->
            <div class="details-result">
                <p class="result-label">
                    {{ $i18n('myBet') }}
                </p>
                <p class="result-value" :style="{ 'color': betColor }">
                    {{ $i18n(history.sector) }}
                </p>
                <p class="result-label">
                    {{ $i18n('winner') }}
                </p>
                <p class="result-value" :style="{ 'color': resultColor }">
                    {{ resultValue && $i18n(resultValue) }}
                </p>
            </div>
            <!-- 轮盘指针 -->
            <span class="arrow-down" :style="{ 'border-color': `${resultColor} transparent transparent`  }" />
        </div>
    </div>
</template>

<script lang="ts">
export enum colors {
    gray = '#5b6773',
    red = '#fa305c',
    green = 'rgb(50, 213, 78)',
    yellow = '#fed700'
}
</script>
<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { circleSectors } from '@/pages/casino/circleGame/data';

const $i18n = useI18n().t;
// 我的押注颜色
const betColor = ref('');
// 赢家结果颜色
const resultColor = ref('');
// 赢家结果
const resultValue = ref('');
// 赢家结果对应的轮盘旋转角度
const degree = ref('');

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
})
watch(() => props.history, (newVal) => {
    if (newVal){
        betColor.value = colors[newVal.sector];
        // 下注结果
        const seedIndex = Number(newVal?.randomSeed.split('_')[0]);
        const betResult = circleSectors[seedIndex];

        resultColor.value = Object.values(colors)[betResult - 1];
        resultValue.value = Object.keys(colors)[betResult - 1];
        const deg = 360 / circleSectors.length * seedIndex;
        degree.value = `transform: rotate(${deg}deg)`;
    }
}, {
    deep: true,
    immediate: true
})
</script>

<style lang="scss" scoped>
.circle-details {
    // padding-bottom: 20px;
    .details-board {
        align-items: center;
        background-color: inherit;
        border: 4px solid transparent;
        border-radius: 50%;
        display: flex;
        height: 250px;
        justify-content: center;
        margin: auto;
        position: relative;
        transform-origin: 50% 50%;
        transition: border 1.5s;
        width: 250px;
        will-change: transform;
        .details-result {
            display: flex;
            flex-direction: column;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%,-50%);
            .result-label {
                color: #55657e;
                font-size: 15px;
                font-weight: 500;
                text-align: center;
            }
            .result-value {
                color: #fed700;
                font-size: 40px;
                font-weight: 700;
                line-height: 47px;
                text-align: center;
                white-space: nowrap;
            }
        }
        .arrow-down {
            border-style: solid;
            border-width: 19px 14.5px 0;
            bottom: 115px;
            height: 0;
            position: absolute;
            right: -30px;
            transform: translate(-50%) rotate(90deg);
            width: 0;
        }
    }
}
</style>